import * as React from 'react';
import './TopBar.css';

const TopBar = () => {

    return (
        <div className='appbar'>

        </div>
    )
}

export default TopBar